go-icon {
  --icon-size: 1em;
  --icon-color: currentColor;

  &[icon-set^='material'] {
    --icon-size: 1.5em;
    vertical-align: middle;
    .go-icon {
      transform: rotate(0.03deg); // https://github.com/google/material-design-icons/issues/648
      line-height: 1em;
      display: inherit;
    }
  }

  display: inline-block;
  line-height: 1;
  .go-icon {
    font-size: var(--icon-size);
    color: var(--icon-color);
  }
}
